import React from "react"
import { NeoButton } from "../../../components/Common"

import {
  addDays,
  getStepForView,
  formatRangeLabel,
  getStartOfWeek
} from "../../../utils/date"

const WeekNavigator = ({ referenceDate, view, onReferenceDateChange }) => {
  const step = getStepForView(view)

  let startDate = referenceDate
  let endDate = referenceDate

  if (view === 'week') {
    startDate = getStartOfWeek(referenceDate)
    endDate = addDays(startDate, 6)
  }

  const label = formatRangeLabel(startDate, endDate, view)

  return (
    <div className="d-flex align-items-center gap-2">
      <NeoButton
        variant="outline-chocolate"
        size="sm"
        icon="mdi-chevron-left"
        onClick={() => onReferenceDateChange(addDays(referenceDate, -step))}
      />
      <div className="text-muted small fw-semibold text-uppercase">{label}</div>
      <NeoButton
        variant="outline-chocolate"
        size="sm"
        icon="mdi-chevron-right"
        onClick={() => onReferenceDateChange(addDays(referenceDate, step))}
      />
    </div>
  )
}

export default WeekNavigator
